import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';

@Component({
  selector: 'app-end-live-chat',
  templateUrl: './end-live-chat.component.html',
  styleUrls: ['./end-live-chat.component.css']
})
export class EndLiveChatComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<EndLiveChatComponent>,public chatbotFunService: ChatbotFunService) {}
  
  ngOnInit() {
  }

  onCancel(): void {
    this.dialogRef.close(false); // Close dialog with 'false', meaning don't close the chat
  }

  onConfirm(): void {
    this.dialogRef.close(true); // Close dialog with 'true', meaning close the chat
  }
}
